import { Staff } from '../lib/staff';

export type BfsFinancingPermissionId = (typeof Permissions)[number]['id'];
export const Permissions = <const>[
  {
    id: 'bfs_FinanceAdmin',
    display: {
      title: 'Budco Financial Services Finance Admin',
      description: 'View the Budco Financial Services (BFS) Financing dashboard and export financing reports.',
    },
  },
];
Permissions.forEach(p => new Staff.Security.Permission(p));
